export default {
    state: () => ({
        Neuro: [
            {
                name: "Базовый процессор",
                code: "M",
                price: 1000,
                humanity: "1d6",
                title: "Обязателен для всех систем"
            },
            {
                name: "Биомонитор",
                code: "N",
                price: 100,
                humanity: "1",
                title: "Сопротивление +2 к пыткам и наркотикам"
            },
            {
                name: "Карезников",
                code: "N",
                price: 500,
                humanity: "1d6 / 2d6",
                title: "Доб. +1 к броскам инициативы за каждый купленный уровень"
            },
            {
                name: "Сэндвистэн",
                code: "N",
                price: 1600,
                humanity: "1d6 / 2",
                title: "Доб. +3 к броскам инициативы на 5 ходов"
            },
            {
                name: "Тактильное усиление",
                code: "N",
                price: 100,
                humanity: "2",
                title: "Доб. +2 при любой тактильной проверке осведомленности"
            },
            {
                name: "Обонятельное усиление",
                code: "N",
                price: 100,
                humanity: "2",
                title: "Повышение осведомленности через обоняние +2"
            },
            {
                name: "Редактор боли",
                code: "N",
                price: 200,
                humanity: "2d6",
                title: "Блокирует жар, холод, боль"
            },
            {
                name: "Коннектор для кибермодема",
                code: "N",
                price: 100,
                humanity: "1",
                title: "Позволяет прямое подключение к к.-модему"
            },
            {
                name: "Коннектор для транспорта",
                code: "N",
                price: 100,
                humanity: "3",
                title: "Только для прямого упр. траспортным средством."
            },
            {
                name: "Коннектор для умного оружия",
                code: "N",
                price: 100,
                humanity: "2",
                title: "Только для работы с прямым подключением к умному оружию"
            },
            {
                name: "Коннектор для механизмов/техники",
                code: "N",
                price: 100,
                humanity: "2",
                title: "Позволяет анализировать станки, большие и малые механизмы"
            },
            {
                name: "Коннектор для терминала данных",
                code: "N",
                price: 100,
                humanity: "2",
                title: "Позволяет скачивать из Терминалов данных во внутр. память"
            },
            {
                name: "Интерфейсные разъемы",
                code: "M",
                price: 200,
                humanity: "1d6/пара",
                title: "Позволяет прямое подключение к умн. оружию, транспорту, чипам"
            },
            {
                name: "Комплект разъемов для чипсета",
                code: "N",
                price: 200,
                humanity: "1d6/2",
                title: "Чипы смотри в разделе ЧИПЫ. Вмещает 10 чипов"
            },
        ],

        Body: [
            {
                name: "Назальные фильтры",
                code: "M",
                price: 60,
                humanity: "2",
                title: "Останавливает токс. пары и газ. Эффективность 80%"
            },
            {
                name: "Жабры",
                code: "MA",
                price: 400,
                humanity: "3d6",
                title: "Водное дыхания на 4 часа"
            },
            {
                name: "Независимая подача кислорода",
                code: "MA",
                price: 300,
                humanity: "2d6",
                title: "Независимая подача воздуха на протяжении 25 минут"
            },
            {
                name: "Подкожный карман",
                code: "M",
                price: 200,
                humanity: "2d6",
                title: "Полость с застежкой “Realskinn™"
            },
            {
                name: "Усиление надпочечников",
                code: "M",
                price: 400,
                humanity: "2d6",
                title: "Усиливает Рефлексы +1 на 1d6+2 хода, 3 раза в день."
            },
            {
                name: "Подкожная броня",
                code: "CR",
                price: 1200,
                humanity: "2d6",
                title: "Броня SP +18"
            },
            {
                name: "Детектор движения",
                code: "M",
                price: 200,
                humanity: "2d6",
                title: "Обнаруживает движение в области 20 кв. м"
            },
            {
                name: "Цифровой рекордер",
                code: "M",
                price: 200,
                humanity: "2",
                title: "Хранилище на 2 часа записи из любого цифрового хранилища"
            },
            {
                name: "Аудио/Видео магнитофон",
                code: "M",
                price: 300,
                humanity: "2",
                title: "Хранилище для Ау/Ви дорожек на 2 час"
            },
            {
                name: "Радарный датчик",
                code: "M",
                price: 200,
                humanity: "2",
                title: "Радиолокатор дальностью 100 м. В наличии должна быть к.-оптика. Эффективность 70%"
            },
            {
                name: "Сонар",
                code: "M",
                price: 300,
                humanity: "2",
                title: "Сонар дальностью 50 м. Только для воды. Эфф. 70%"
            },
            {
                name: "Детектор радиации",
                code: "M",
                price: 200,
                humanity: "2",
                title: "Дальность 10 м. Эффективность обнаружения 80%"
            },
            {
                name: "Химический анализатор",
                code: "M",
                price: 200,
                humanity: "2",
                title: "Дальность 5 м. Эфф. обн. 70%"
            },
            {
                name: "Синтезатор голоса",
                code: "M",
                price: 600,
                humanity: "1d6",
                title: "Может имитировать любой записанный звук (60%), до 10 звуков."
            },
            {
                name: "АудиоВокс",
                code: "M",
                price: 700,
                humanity: "2d6",
                title: "Вокальный синтезатор для спецэффектов. +2 к Выступлению"
            },
        ],

        Bioupgrade: [
            {
                name: "Наращенные мышцы",
                code: "MA",
                price: "1000 за 1",
                humanity: "2d6",
                title: "Усиливает Телосложение на +2"
            },
            {
                name: "Оплетка мускул и костей",
                code: "N",
                price: 1500,
                humanity: "1d6/2",
                title: "Повышает Телосложение на +2"
            },
            {
                name: "Прошивка кожи",
                code: "N",
                price: 2000,
                humanity: "2d6",
                title: "Броня тела SP +12"
            },
            {
                name: "Усиленные антитела",
                code: "N",
                price: 3000,
                humanity: "1d6 / 2",
                title: "Улучшает исцеление на +1 пункт в день"
            },
            {
                name: "Блокировщики токсинов",
                code: "N",
                price: 3000,
                humanity: "1d6/2",
                title: "Улучшает защиту от ядов и наркотиков на +4"
            },
            {
                name: "Нанохирурги",
                code: "N",
                price: 6000,
                humanity: "1d6/2",
                title: "Удваивает скорость исцеления"
            },
        ],

        Meleeweapons: [
            {
                name: "Коготки",
                code: "N",
                price: 100,
                humanity: "2d6",
                title: "Телесное ружие (руки). Урон 1d6/2"
            },
            {
                name: "Клыки вампира",
                code: "N",
                price: 200,
                humanity: "3d6",
                title: "Телесное оружие (рот). Урон 1d6/3"
            },
            {
                name: "Потрошители",
                code: "M",
                price: 400,
                humanity: "3d6",
                title: "Руки. Урон 1d6+3 (считается холодным)"
            },
            {
                name: "Волки",
                code: "M",
                price: 600,
                humanity: "3d6+1",
                title: "Руки. Урон 3d6 (холодное)"
            },
            {
                name: "Большие костяшки",
                code: "M",
                price: 500,
                humanity: "3d6",
                title: "Руки. Урон 1d6+2"
            },
            {
                name: "Моноструна",
                code: "M",
                price: 700,
                humanity: "3d6",
                title: "Руки. Урон 2d6"
            },
            {
                name: "Кибер-змея",
                code: "MA",
                price: 1200,
                humanity: "4d6",
                title: "Кибер-оружие. Самоконтролирующееся. Урон 1d6"
            },
        ],

        Optica: [
            {
                name: "Базовый глазной модуль",
                code: "MA",
                price: 500,
                humanity: "2d6",
                title: "Возможно добавить до 4 опций на 1 глаз из списка ниже"
            },
            {
                name: "Улучшитель изображения",
                code: "N",
                price: 300,
                humanity: "1",
                title: "Доб. +2 Осведомленности при визуальном поиске"
            },
            {
                name: "Прицельный видоискатель",
                code: "N",
                price: 400,
                humanity: "2",
                title: "Доб. +1 ко всем атакам из умного оружия"
            },
            {
                name: "Всплывающее окно",
                code: "N",
                price: 300,
                humanity: "1",
                title: "Экран сообщений в поле зрения"
            },
            {
                name: "Телескопическая оптика",
                code: "N",
                price: 150,
                humanity: "0.5",
                title: "Зумирование х20"
            },
            {
                name: "Микро-оптика",
                code: "N",
                price: 150,
                humanity: "0.5",
                title: "Микроскоп"
            },
            {
                name: "Защита от ослепления",
                code: "N",
                price: 200,
                humanity: "0.5",
                title: "Невосприимчивость к ослеплению вспышками и лазерами"
            },
            {
                name: "LL - ночное зрение",
                code: "N",
                price: 200,
                humanity: "0.5",
                title: "Видишь в слабом свете, почти в полной темноте"
            },
            {
                name: "Тепловизор",
                code: "N",
                price: 200,
                humanity: "1",
                title: "Тепловой рисунок и определение Т"
            },
            {
                name: "Инфракрасная оптика",
                code: "N",
                price: 200,
                humanity: "1",
                title: "Видишь в полной темноте, используя источники тепла"
            },
            {
                name: "Ультрафиолетовая оптика",
                code: "N",
                price: 200,
                humanity: "1",
                title: "Видишь в темноте, используя УФ подс."
            },
            {
                name: "Микро-видео камера",
                code: "N",
                price: 300,
                humanity: "0.5",
                title: "Запись до 20 мин. Занимает два слота опции"
            },
            {
                name: "Цифровая фотокамера",
                code: "N",
                price: 300,
                humanity: "0.5",
                title: "До 20 изображений (занимает 2 опции)"
            },
            {
                name: "Дротикомет",
                code: "N",
                price: 200,
                humanity: "2",
                title: "Отравленное оружие. (занимает 3 ячейки опции) Заряжен 1 дротиком"
            },
        ],

        Audio: [
            {
                name: "Базовый слуховой модуль",
                code: "M",
                price: 500,
                humanity: "2d6",
                title: "Ограничений на опции из списка ниже нет"
            },
            {
                name: "Усиленный слух",
                code: "N",
                price: 200,
                humanity: "1",
                title: "Доб +1 к Осведомленности при поиске источников звука"
            },
            {
                name: "Радио-коннектор",
                code: "N",
                price: 100,
                humanity: "1",
                title: "Радиосвяз до 1 мили"
            },
            {
                name: "Телефонное соединение",
                code: "N",
                price: 150,
                humanity: "1",
                title: "Полная сотовая связь (только в большом городе)"
            },
            {
                name: "Скремблер",
                code: "N",
                price: 100,
                humanity: "0.5",
                title: "Невозможно прослушать связь без дешифратора"
            },
            {
                name: "Детектор жучков",
                code: "N",
                price: 200,
                humanity: "0.5",
                title: "Обнаружение меток и жучков до 3 м. Эффективность 60%"
            },
            {
                name: "Анализатор голосовых паттернов",
                code: "N",
                price: 200,
                humanity: "1",
                title: "Детектор лжи. +2 к Пониманию людей и Допросу"
            },
            {
                name: "Редактор звука",
                code: "N",
                price: 150,
                humanity: "0.5",
                title: "Доб +2 к Осведомленности, чтобы услышать один конкретный разговор"
            },
            {
                name: "Расширенный слуховой диапозон",
                code: "N",
                price: 150,
                humanity: "2",
                title: "Способность слышать сверхзвуковые, дозвуковые диапозоны"
            },
            {
                name: "Детектор радара",
                code: "N",
                price: 150,
                humanity: "0.5",
                title: "Подает звуковой сигнал, если обнаружен радарный компонент, фиксирует источник (40%)"
            },
            {
                name: "Трассер обратного пути",
                code: "N",
                price: 200,
                humanity: "0.5",
                title: "Можно следить за меткой до 1 км"
            },
            {
                name: "Линия радиосвязи по прямому лучу",
                code: "N",
                price: 200,
                humanity: "1",
                title: "Позволяет вести не перехватываемую радио комуникацию"
            },
            {
                name: "Широкополосный радио сканер",
                code: "N",
                price: 100,
                humanity: "2",
                title: "Перехватывает все радиопередачи на всех диапозонах. Сканер"
            },
            {
                name: "Коннектор микро-рекордера",
                code: "N",
                price: 100,
                humanity: "0.5",
                title: "Передает на рекордер в теле или через разъемы"
            },
            {
                name: "Коннектор цифрового рекордера",
                code: "N",
                price: 100,
                humanity: "0.5",
                title: "Передает звуки на цифровой рекордер"
            },
            {
                name: "Демпфер уровня",
                code: "N",
                price: 300,
                humanity: "0.5",
                title: "Автоматическая компенсация шума"
            },
        ],

        Handleg: [
            {
                name: "Кибер-рука",
                code: "CR",
                price: 3000,
                humanity: "2d6",
                title: "Стандартная замена конечности (доступно 4 опции из списка ниже)"
            },
            {
                name: "Кибер-нога",
                code: "CR",
                price: 2000,
                humanity: "2d6",
                title: "Стандартная замена ноги (доступно 3 опции из списка ниже)"
            },
            {
                name: "Быстросменное крепление",
                code: "N",
                price: 200,
                humanity: "2",
                title: "Позволяет за 1 ход менять кибер-конечность"
            },
            {
                name: "Гидравлические цилиндры",
                code: "N",
                price: 200,
                humanity: "3",
                title: "Увеличивает прочность SDP +30 х3 обычного урона"
            },
            {
                name: "Уплотненные миомарные волокна",
                code: "N",
                price: 250,
                humanity: "2",
                title: "Увеличивает прочность SDP +25 х2 обычного урона"
            },
            {
                name: "Усиленные суставы",
                code: "N",
                price: 200,
                humanity: "1",
                title: "Увеличивает прочность SDP +5"
            },
            {
                name: "Искусственные плечи",
                code: "CR",
                price: 1500,
                humanity: "2d6",
                title: "Установка доп рук (2) Только 1 комплект"
            },
            {
                name: "Микроволновое и ЭМИ экранирование",
                code: "N",
                price: 300,
                humanity: "1",
                title: "Конечность не подвержена микроволновым побочкам"
            },
            {
                name: "RealSkinn™",
                code: "N",
                price: 200,
                humanity: "-",
                title: "Конечност выглядит реальной. Сложная задача для обнаружения (20) Снижает цену человечности на 1d6/2"
            },
            {
                name: "Броня",
                code: "N",
                price: 200,
                humanity: "1d6",
                title: "Бронирование конечности на +20 SP"
            },
        ],

        Armfoot: [
            {
                name: "Кисть-потрошитель",
                code: "N",
                price: 600,
                humanity: "2d6",
                title: "Стандартная рука со встроенными Потрошителями"
            },
            {
                name: "Кисть-молот",
                code: "N",
                price: 600,
                humanity: "2d6",
                title: "Гидравлический таранный кулак, наносит 1d6 урона"
            },
            {
                name: "Кисть-триммер",
                code: "N",
                price: 600,
                humanity: "2d6",
                title: "Подключенная циркулярная пила. 2d6+2 урона. Мягкая броня уменьшена"
            },
            {
                name: "Кисть-инструментарий",
                code: "N",
                price: 200,
                humanity: "2",
                title: "Пальцы содержат отвертку, гаечный ключ, дрель и т.д."
            },
            {
                name: "Кисть-грейфер",
                code: "N",
                price: 350,
                humanity: "3",
                title: "Вытягивающийся грейфер (хваталка) с ракетным двигателем на 30 м тросе"
            },
            {
                name: "Удлиняющаяся кисть",
                code: "N",
                price: 350,
                humanity: "2",
                title: "Рука выдвигается из складного рукава до 1 м"
            },
            {
                name: "Кисть с шипом",
                code: "N",
                price: 500,
                humanity: "2d6",
                title: "Шипы, выдвигающиеся сквозь пальцы 1d6+3 бронебойного урона (AP)"
            },
            {
                name: "Модульная кисть",
                code: "N",
                price: 600,
                humanity: "2",
                title: "Выбери 4 любых модульных инструмента"
            },
            {
                name: "Когтистая ступня",
                code: "N",
                price: 600,
                humanity: "2d6",
                title: "Выдвижной клинок из пальца ноги 1d6 урона (холодное)"
            },
            {
                name: "Ступня-инструментарий",
                code: "N",
                price: 300,
                humanity: "2",
                title: "Пальцы ног содержат отвертку, гаечный ключ, дрельку и т.д."
            },
            {
                name: "Перепончатая ступня",
                code: "N",
                price: 500,
                humanity: "2",
                title: "Двойная скорость плавания. +3 к навыку Плавание"
            },
            {
                name: "Обхватывающая ступня",
                code: "N",
                price: 500,
                humanity: "2",
                title: "Разработана для улучшения силы хвата. +2 чтобы карабкаться ввех."
            },
            {
                name: "Пяточный шип",
                code: "N",
                price: 500,
                humanity: "2d6",
                title: "Шип из пяты, для скалолазания или смертельных ударов. Урон 2d6 (холодное)"
            },
        ],

        Elementsforlimb: [
            {
                name: "Аудио-видео магнитофон",
                code: "N",
                price: 250,
                humanity: "1",
                title: "Хранение 2 часов записи на микрокассете (покупается отдельно)"
            },
            {
                name: "Кибер-модем",
                code: "N",
                price: 3000,
                humanity: "1",
                title: "Подключается к Кибердеке. (5000 за Сотовую версию)"
            },
            {
                name: "Цифровой рекордер",
                code: "N",
                price: 300,
                humanity: "1",
                title: "Чип-рекордер. Позволяет стирать и записывать на чип"
            },
            {
                name: "Место для хранения",
                code: "N",
                price: 50,
                humanity: "0.5",
                title: "Пространство для хранения 5х15х5 см (может быть заблокировано)"
            },
            {
                name: "Мини фотоаппарат",
                code: "N",
                price: 200,
                humanity: "2",
                title: "Всплывающая камера на 20 снимков"
            },
            {
                name: "Мини камера",
                code: "N",
                price: 400,
                humanity: "2",
                title: "Всплывающая камера на 30 минут"
            },
            {
                name: "Потайная кобура",
                code: "N",
                price: 100,
                humanity: "1",
                title: "Размер оружия в зависимости от Телосложения"
            },
            {
                name: "Считывающий ЖК-экран",
                code: "N",
                price: 200,
                humanity: "1",
                title: "Может быть связан с любым устройством вывода"
            },
            {
                name: "Технический сканер",
                code: "N",
                price: 4000,
                humanity: "3",
                title: "Небольшой портативный микрокомпьютер с различными щупами и разъёмами ввода / вывода. Технические сканеры запускают диагностические программы, выявляют и проверяют неисправные компоненты,  и отображают внутренние схемы на небольшом экране"
            },
        ],

        Rangeweaponforlimb: [
            {
                name: "Гранатомет",
                code: "N",
                price: 500,
                humanity: "2d6",
                title: "Заряжено 1 гранатой любого типа"
            },
            {
                name: "Микро-ракетная пусковая установка",
                code: "N",
                price: 900,
                humanity: "2d6",
                title: "Заряжено 4 мини-ракетами, 4d6 урона каждая."
            },
            {
                name: "Всплывающее оружие",
                code: "N",
                price: "от 2 до 800",
                humanity: "2d6",
                title: "Доступный размер зависит от Телосложения"
            },
            {
                name: "Огнемет",
                code: "N",
                price: 600,
                humanity: "2d6",
                title: "Урон 2d6 за 1-й ход, 1d6/2 на 2 последующих хода."
            },
            {
                name: "Крепление для оружия и коннектор",
                code: "N",
                price: 100,
                humanity: "3",
                title: "Монтажная пластина плюс нейронная связь для 1 оружия"
            },
            {
                name: "2 зарядный конденсаторный лазер",
                code: "N",
                price: 800,
                humanity: "2d6",
                title: "Лазерный конденсатор на 2 выстрела"
            },
        ],

        Exzoarmor: [
            {
                name: "Капюшон",
                code: "MA",
                price: 200,
                humanity: "1d6",
                title: "Защита черепа, покрывает голову. SP броня = 25. (не покрывает лицо)"
            },
            {
                name: "Лицевая пластина",
                code: "CR",
                price: 400,
                humanity: "4d6",
                title: "Защищающая маска на 25 SP брони"
            },
            {
                name: "Покрытие торса пластинами",
                code: "MA",
                price: 2000,
                humanity: "3d6",
                title: "Защита торса на 25 SP брони"
            },
            {
                name: "Фронтальное оптическое крепление",
                code: "MA",
                price: 1000,
                humanity: "4d6",
                title: "Позволяет установить до 5 единиц оптики на лицо"
            },
            {
                name: "Сенсорный отросток -Кроличьи уши",
                code: "M",
                price: "500 за 1",
                humanity: "3d6",
                title: "Наголовное крепление для слуховой и оптической аппаратуры и т.д."
            },
        ],

        Rama: [
            {
                name: "Рама СИГМА",
                code: "MA",
                price: 6000,
                humanity: "2d6",
                title: "Сила = 12 вместо своей. В них нельзя плавать и они уменьшают СТАТу Рефлексов на -1"
            },
            {
                name: "Рама БЕТА",
                code: "MA",
                price: 8000,
                humanity: "2d6",
                title: "Сила = 14. В них нельзя плавать и они уменьшают СТАТу Рефлексов на -1"
            },
            {
                name: "Рама ОМЕГА",
                code: "MA",
                price: 10000,
                humanity: "3d6",
                title: "Сила = 16. В них нельзя плавать и они уменьшают СТАТу Рефлексов на -1"
            },
        ],
    }),
}